let cache = null;
let loadPromise = null;

/**
 * Loads the bundled Functional Fitness exercise database (JSON in /public/data).
 * Safe to call repeatedly; result is cached in memory.
 */
export async function loadExerciseDatabase() {
  if (cache) return cache;
  if (!loadPromise) {
    const base = import.meta.env.BASE_URL || "/";
    const url = `${base}data/exercise-database.json`;
    loadPromise = fetch(url)
      .then((r) => {
        if (!r.ok) throw new Error(`Exercise database HTTP ${r.status}`);
        return r.json();
      })
      .then((data) => {
        cache = data;
        return data;
      });
  }
  return loadPromise;
}

export function filterExercisesByMuscle(data, muscleGroup) {
  if (!data?.exercises) return [];
  const m = String(muscleGroup || "").trim().toLowerCase();
  if (!m) return data.exercises;
  return data.exercises.filter(
    (e) =>
      String(e.targetMuscleGroup || "")
        .trim()
        .toLowerCase() === m
  );
}

/** Case-insensitive substring match on exercise name */
export function searchExerciseNames(data, query, muscleGroup, limit = 80) {
  if (!data?.exercises) return [];
  const q = String(query || "")
    .trim()
    .toLowerCase();
  let list = filterExercisesByMuscle(data, muscleGroup);
  if (!q) return list.slice(0, limit);
  const out = [];
  for (const ex of list) {
    const n = String(ex.name || "").toLowerCase();
    if (n.includes(q)) {
      out.push(ex);
      if (out.length >= limit) break;
    }
  }
  return out;
}
